import { ChangelogBaseFragment } from '@cycle-app/graphql-codegen';
import { Skeleton } from '@cycle-app/ui';
import { FormProvider } from 'react-hook-form';

import { useChangelogBuilderForm } from '../../hooks/releases/useChangelogBuilderForm';
import { ChangelogTitle } from '../PageTitle/PageTitle';
import { Container, Main } from './ChangelogBuilder.styles';
import { ChangelogBuilderContent } from './ChangelogBuilderContent';
import { ChangelogBuilderSidebar } from './ChangelogBuilderSidebar';
import { Container as SidebarContainer, Top } from './ChangelogBuilderSidebar.styles';
import { ChangelogBuilderSubmit } from './ChangelogBuilderSubmit';

type Props = {
  changelog: ChangelogBaseFragment;
};

export const ChangelogBuilder = ({ changelog }: Props) => {
  const form = useChangelogBuilderForm({ changelog });
  return (
    <FormProvider {...form}>
      <ChangelogTitle />
      <Container>
        <ChangelogBuilderSidebar />
        <Main>
          <ChangelogBuilderSubmit />
          <ChangelogBuilderContent />
        </Main>
      </Container>
    </FormProvider>
  );
};

export const ChangelogBuilderLoader = () => {
  return (
    <Container>
      <SidebarContainer>
        <Top>
          <Skeleton height={26} />
        </Top>
      </SidebarContainer>
      <Main />
    </Container>
  );
};
